import { Component, Input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { sp } from '@pnp/sp/presets/all';
import { SearchResultItem } from 'src/app/services/models';
import { concat } from 'src/app/services/utils';

@Component({
  selector: 'app-search-item-title',
  templateUrl: './search-item-title.component.html'
})
export class SearchItemTitleComponent {
  subClassification: string;
  @Input()
  item: SearchResultItem;

  isLoading = false;
  isLoaded = false;

  isTipClosed = false;

  get openDelay(): number {
    if (this.isLoaded) return 0;
    return 100;
  }

  private subClassificationPromise: Promise<string>

  async openTip(tooTip: NgbTooltip): Promise<void> {
    try {
      this.isTipClosed = false;
      const subClassification = await this.getSubclassification();
      if (subClassification) {
        this.subClassification = subClassification;
        if (!this.isTipClosed) tooTip.open();
      }
    }
    catch (error) {
      console.error('failed to get subclassification %o', error);
    }
  }

  closeTip(toolTip: NgbTooltip) {
    toolTip.close();
    this.isTipClosed = true;
  }

  private getListName(channelName: string): string[] {
    let listName = "";
    let columnName = "Sub_x0020_Classification";
    switch (channelName) {
        case "ESA":
            listName = "HTA Early Scientific Advice";
            columnName = "SubClassification";
            break;
        case "TP":
            listName = "TP1-TP2";
            columnName = "SubClassification";
            break;
        case "HSR":
            listName = "HTASubmission Resources";
            break;
        case "AEM":
            listName = "AEM Metrics";
            columnName = "SubClassification";
            break;
        case "HST":
            listName = "SubmissionTimeline";
            columnName = "SubClassification";
            break;
        case "HMC":
            listName = "HTA Economic Model Cocreation";
            break;
        case "MAAP":
            listName = "Market Access Analysis Plan";
            break;
        case "AC":
            listName = "AC-Resources";
        break;
    
      /* start AccessHUb-3.15-Relese  */
      case "FAQ":
        listName = "FAQQuestions";
        break;
      case "MADB":
        listName = "MarketAccessDatabases";
        break;
      case "HMCNMA":
        listName = "HTA Economic Model ITC-NMA";
        break;
      case "CR":
        listName = "ContractRightBestPracticeExamples";
        break;
      case "AERC":
        listName = "AERCCountryComparisonData";
        break;
      case "ACHTAFAQ":
        listName = "ACHTAFAQQuestions";
        break;
      /* end AccessHUb-3.15-Relese  */
        default:
            break;
    }
    return [listName, columnName];
  }

  private concat

  getSubclassification(): Promise<string> {
    if (!this.subClassificationPromise) {
      const channel = this.item.ChannelAcronym;
      this.isLoading = true;
      const [listName, columnName] = this.getListName(channel);
      if (listName) {
          if (listName === 'AC-Resources') {
            const dataPromise = sp.web.lists.getByTitle(listName).items.select("SubPopulation/Title", "SubTherapy/Title", "SubClinicalTrial/Title")
                  .expand("SubPopulation", "SubTherapy", "SubClinicalTrial").filter(`ID eq '${this.item.ItemId}'`).top(1).get();
            this.subClassificationPromise = dataPromise.then(result => {
              const subclassificationItem = result[0];
              if (subclassificationItem) {
                return concat("  ", subclassificationItem.SubPopulation?.Title,
                  subclassificationItem.SubTherapy?.Title, subclassificationItem.SubClinicalTrial?.Title);
              }
              else return '';
            });
          }
          else {
              const dataPromise = sp.web.lists.getByTitle(listName).items.getById(this.item.ItemId).select(columnName).get();
              this.subClassificationPromise = dataPromise.then(subclassificationItem => subclassificationItem[columnName]);
          }
      }
      else {
        this.subClassificationPromise = Promise.resolve('');
      }
      this.subClassificationPromise.then(() => {
        this.isLoading = false;
        this.isLoaded = true;
      }).catch(() => {
        this.subClassificationPromise = undefined;
        this.isLoading = false;
        this.isLoaded = false;
      });
    }
    return this.subClassificationPromise;
  }
}
